(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('growth', {
            parent: 'entity',
            url: '/growth?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.growth.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/growth/growths.html',
                    controller: 'GrowthController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('growth');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('growth-detail', {
            parent: 'growth',
            url: '/growth/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.growth.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/growth/growth-detail.html',
                    controller: 'GrowthDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('growth');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Growth', function($stateParams, Growth) {
                    return Growth.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'growth',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('growth-detail.edit', {
            parent: 'growth-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/growth/growth-dialog.html',
                    controller: 'GrowthDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Growth', function(Growth) {
                            return Growth.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('growth.new', {
            parent: 'growth',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/growth/growth-dialog.html',
                    controller: 'GrowthDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                location: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('growth', null, { reload: 'growth' });
                }, function() {
                    $state.go('growth');
                });
            }]
        })
        .state('growth.edit', {
            parent: 'growth',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/growth/growth-dialog.html',
                    controller: 'GrowthDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Growth', function(Growth) {
                            return Growth.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('growth', null, { reload: 'growth' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('growth.delete', {
            parent: 'growth',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/growth/growth-delete-dialog.html',
                    controller: 'GrowthDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Growth', function(Growth) {
                            return Growth.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('growth', null, { reload: 'growth' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
